import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useTheme } from '@mui/material'

import {
  AddLiquidityButton,
} from '../../buttons'
import PageDex from './PageDex'

const Title = (): JSX.Element => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
      }}
    >
      <IconButton color="secondary" sx={{ width: 50 }} href="#/pool">
        <ArrowBackIcon />
      </IconButton>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
        }}
        ml={1}
      >
        <Typography variant="h6" sx={{ color: theme.palette.secondary.main }}>Add liquidity</Typography>
        <Typography variant="body2">Add liquidity to receive LP tokens</Typography>
      </Box>
    </Box>
  )
}

const AddLiquidity = (): JSX.Element => (
  <PageDex separator="plus">
    <Title />
    <AddLiquidityButton />
  </PageDex>
)

export default AddLiquidity
